import { forwardRef } from "react";
import { useUser } from "../../../../misc/Permission";
import { PDF } from "../../../../misc/pdf/parts/PDF";
import { PDFProjectContext } from "../../shopdrawing/openings/OpeningsPDF";
import { PageRenderProvider } from "../../../../misc/pdf/parts/PageContext";
import { pdfTableStyle } from "../../../../misc/pdf/parts/Page";
import { ContainerPage } from "../../../../misc/pdf/parts/ContainerPage";
import { useReadyCheck } from "../../../../misc/pdf/UseReadyCheck";
import { RedactedContext } from "../../../../misc/pdf/RedactedContext";
import { fixFinishName } from "../../../../api/Products";
import { isNumber } from "../../../logistics/routes/QtyWithPreview";
import { universalParser } from "../../../../misc/scroller/Table";
import { MetricDistance } from "../../../../misc/MetricDistance";
import { formatPreps } from "../../shopdrawing/extras/preps/PrepUtil";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PriceRequestPDF = /*#__PURE__*/ forwardRef(function (props, ref) { const usr = useUser(); const ready = useReadyCheck(props.onReady); ready.require(!!usr); return /*#__PURE__*/ _jsx("div", { ref: ref, children: /*#__PURE__*/ _jsx(PDF, { children: /*#__PURE__*/ _jsx(PDFProjectContext.Provider, { value: props.project, children: /*#__PURE__*/ _jsx(RedactedContext.Provider, { value: true, children: /*#__PURE__*/ _jsx(PriceRequestTable, { keyName: props.keyName, items: props.items, kind: props.kind, onReady: ready.section(), includePreps: props.includePreps, unitSystem: props.project.unitSystem }) }) }) }) }); });
export function PriceRequestTable(props) { return /*#__PURE__*/ _jsx(PageRenderProvider, { data: props.items, onReady: props.onReady, children: list => /*#__PURE__*/ _jsx(ContainerPage, { children: /*#__PURE__*/ _jsx(PriceTable, { kind: props.kind, keyName: props.keyName, list: list, includePreps: props.includePreps, projectSys: props.unitSystem }) }) }); }
function PriceTable(props) { const tbl = MakePriceTable({ kind: props.kind, keyName: props.keyName, list: props.list.rows, includePreps: !!props.includePreps, projectSys: props.projectSys }); return tbl.toReact(); }
class Table {
    constructor() { this.header = []; this.rows = []; }
    setHeader(values) { this.header = values; }
    addRows(values) { this.rows.push(...values); }
    appendRow(values) { this.rows.push(values); }
    toReact() { return /*#__PURE__*/ _jsxs("table", { className: pdfTableStyle, children: [/*#__PURE__*/ _jsx("thead", { children: /*#__PURE__*/ _jsx("tr", { children: this.header.map((h, index) => /*#__PURE__*/ _jsx("th", { children: h }, index)) }) }), /*#__PURE__*/ _jsx("tbody", { children: this.rows.map((row, index) => /*#__PURE__*/ _jsx("tr", { children: row.map((cell, index) => /*#__PURE__*/ _jsx("td", { children: cell }, index)) }, index)) })] }); }
    toStringArray() { return [this.header, ...this.rows]; }
}
export function MakePriceTable(props) {
    const toMetric = props.projectSys === "metric";
    switch (props.kind) {
        case "div10/wr-accessory": {
            const tbl = new Table();
            tbl.setHeader(["Qty", "Product", "Description", "Code", "Finish"]);
            tbl.addRows(props.list.map(v => [v.qty.toString(), v.categoryName || "", v.productName, v.productCode, fixFinishName(v.finish)]));
            return tbl;
        }
        case "div10/wr-partition": {
            const tbl = new Table();
            tbl.setHeader(["Mounting", "Material", "Description", "Qty"]);
            tbl.addRows(props.list.map(v => { var _v$div, _v$div2, _v$div3; return [((_v$div = v.div10) === null || _v$div === void 0 ? void 0 : _v$div.partitionBracing) || "", ((_v$div2 = v.div10) === null || _v$div2 === void 0 ? void 0 : _v$div2.partitionCoating) || "", ((_v$div3 = v.div10) === null || _v$div3 === void 0 ? void 0 : _v$div3.description) || "", v.qty.toString()]; }));
            return tbl;
        }
        case "div10/locker": {
            const tbl = new Table();
            tbl.setHeader(["Tiers", "Material", "Sloped Tops", "End Panels", "Base Trim", "Width", "Depth", "Height", "Qty"]);
            tbl.addRows(props.list.map(v => { var _v$div4, _v$div5, _v$div6, _v$div7, _v$div8; return [((_v$div4 = v.div10) === null || _v$div4 === void 0 ? void 0 : _v$div4.lockerTiers) || "", ((_v$div5 = v.div10) === null || _v$div5 === void 0 ? void 0 : _v$div5.lockerCoating) || "", yesNo((_v$div6 = v.div10) === null || _v$div6 === void 0 ? void 0 : _v$div6.lockerSloped), yesNo((_v$div7 = v.div10) === null || _v$div7 === void 0 ? void 0 : _v$div7.lockerEndPanels), yesNo((_v$div8 = v.div10) === null || _v$div8 === void 0 ? void 0 : _v$div8.lockerBaseTrim), v.dimWidth.toString(), v.dimLength.toString(), v.dimHeight.toString(), v.qty.toString()]; }));
            return tbl;
        }
        case "div10/mailbox": {
            const tbl = new Table();
            tbl.setHeader(["Tenant Units", "Parcel Units", "Loading", "Mounting", "Qty"]);
            tbl.addRows(props.list.map(v => { var _v$div9, _v$div10, _v$div11, _v$div12; return [((_v$div9 = v.div10) === null || _v$div9 === void 0 ? void 0 : _v$div9.mailboxTenantUnits.toString()) || "", ((_v$div10 = v.div10) === null || _v$div10 === void 0 ? void 0 : _v$div10.mailboxParcelUnits.toString()) || "", ((_v$div11 = v.div10) === null || _v$div11 === void 0 ? void 0 : _v$div11.mailboxLoading) || "", ((_v$div12 = v.div10) === null || _v$div12 === void 0 ? void 0 : _v$div12.mailboxMounting) || "", v.qty.toString()]; }));
            return tbl;
        }
        case "div10/corner-guard": {
            const tbl = new Table();
            tbl.setHeader(["Type", "Code", "Finish", "Width", "Height", "Qty"]);
            tbl.addRows(props.list.map(v => { var _v$div13, _v$div14; return [((_v$div13 = v.div10) === null || _v$div13 === void 0 ? void 0 : _v$div13.cornerGuardType) || "", v.productCode, ((_v$div14 = v.div10) === null || _v$div14 === void 0 ? void 0 : _v$div14.cornerGuardFinish) || "", v.dimWidth.toString(), v.dimHeight.toString(), v.qty.toString()]; }));
            return tbl;
        }
        case "frame": {
            if (props.keyName === "frame-prep") {
                const tbl = new Table();
                const header = ["Description", "Qty"];
                tbl.setHeader(header);
                tbl.addRows(props.list.map(v => {
                    const list = [
                        v.itemName, v.qty.toString()
                    ];
                    return list;
                }));
                return tbl;
            }
            const tbl = new Table();
            let header = ["Qty", "Series", "Material", "Type", "Screen Elev", "Gauge", "Construction", "Profile", "Width", "Height", "Jamb Depth", "Door Thickness", "Label"];
            if (props.includePreps) {
                header.push("Preps");
            }
            tbl.setHeader(header);
            tbl.addRows(props.list.map(v => { if (!v.frame)
                return []; let list = [v.qty.toString(), v.frame.series, v.frame.material, v.frame.type, v.frame.screenElev, v.frame.gauge, v.frame.construction, v.frame.profile, fixSoftMetric(v.frame.width, toMetric), fixSoftMetric(v.frame.height, toMetric), v.frame.jambDepth.toString(), v.frame.doorThickness.toString(), v.frame.label]; if (props.includePreps) {
                list.push(formatPreps(v.frame.preps, "frame"));
            } return list; }));
            return tbl;
        }
        case "door": {
            if (props.keyName === "door-prep/wd" || props.keyName === "door-prep/hm") {
                const tbl = new Table();
                const header = ["Description", "Qty"];
                tbl.setHeader(header);
                tbl.addRows(props.list.map(v => {
                    const list = [
                        v.itemName, v.qty.toString()
                    ];
                    return list;
                }));
                return tbl;
            }
            const tbl = new Table();
            if (props.keyName === "door-wd") {
                let header = ["Qty", "Series", "Material", "Finish", "Core", "Seam", "Elevation", "Width", "Height", "Thickness", "Label"];
                if (props.includePreps) {
                    header.push("Preps");
                }
                tbl.setHeader(header);
                tbl.addRows(props.list.map(v => { if (!v.door)
                    return []; let list = [v.qty.toString(), v.door.series, v.door.material, v.door.finish, v.door.core, v.door.seam, v.door.elevation, fixSoftMetric(v.door.width, toMetric), fixSoftMetric(v.door.height, toMetric), v.door.thickness.toString(), v.door.label]; if (props.includePreps) {
                    list.push(formatPreps(v.door.preps, "door"));
                } return list; }));
            }
            else if (props.keyName === "door-hm") {
                let header = ["Qty", "Series", "Material", "Gauge", "Core", "Seam", "Elevation", "Width", "Height", "Thickness", "Label"];
                if (props.includePreps) {
                    header.push("Preps");
                }
                tbl.setHeader(header);
                tbl.addRows(props.list.map(v => { if (!v.door)
                    return []; let list = [v.qty.toString(), v.door.series, v.door.material, v.door.gauge, v.door.core, v.door.seam, v.door.elevation, fixSoftMetric(v.door.width, toMetric), fixSoftMetric(v.door.height, toMetric), v.door.thickness.toString(), v.door.label]; if (props.includePreps) {
                    list.push(formatPreps(v.door.preps, "door"));
                } return list; }));
            }
            else {
                let header = ["Qty", "Series", "Material", "Core", "Seam", "Elevation", "Width", "Height", "Thickness", "Label"];
                if (props.includePreps) {
                    header.push("Preps");
                }
                tbl.setHeader(header);
                tbl.addRows(props.list.map(v => { if (!v.door)
                    return []; let list = [v.qty.toString(), v.door.series, v.door.material, v.door.core, v.door.seam, v.door.elevation, fixSoftMetric(v.door.width, toMetric), fixSoftMetric(v.door.height, toMetric), v.door.thickness.toString(), v.door.label]; if (props.includePreps) {
                    list.push(formatPreps(v.door.preps, "door"));
                } return list; }));
            }
            return tbl;
        }
        default:
        case "hardware": {
            const tbl = new Table();
            tbl.setHeader(["Qty", "Name", "Code", "Finish", "Length", "Width", "Height"]);
            const getName = v => { return v.productName || v.categoryName || ""; };
            if (props.hardwareManufacturerSeparators) {
                props.list.sort((a, b) => { if (a.manufacturerName !== b.manufacturerName) {
                    return a.manufacturerName.localeCompare(b.manufacturerName);
                } if ("categorySortOrder" in a && isNumber(a.categorySortOrder) && "categorySortOrder" in b && isNumber(b.categorySortOrder)) {
                    return a.categorySortOrder - b.categorySortOrder;
                } return getName(a).localeCompare(getName(b)); });
            }
            let lastMfgId = -1;
            tbl.addRows(props.list.flatMap(v => { const rows = []; if (props.hardwareManufacturerSeparators) {
                if (lastMfgId !== v.manufacturer) {
                    rows.push([v.manufacturerName]);
                    lastMfgId = v.manufacturer;
                }
            } rows.push([v.qty.toString(), getName(v), v.productCode, fixFinishName(v.finish), v.dimLength.toString(), v.dimWidth.toString(), v.dimHeight.toString()]); return rows; }));
            return tbl;
        }
    }
}
export function yesNo(tf) { if (tf === undefined)
    return "-"; return tf ? "Yes" : "No"; }
function fixSoftMetric(value, convert) { if (!convert)
    return value; if (value.indexOf("mm") !== -1) {
    return value;
} const uu = universalParser(value); return MetricDistance.fromUniversal(uu).toString(); }
